import type { Dict } from "../core.js";
import type { support as vi } from "../vi/support.js";

/** Namespace `support` — PLAT-2026-115, English. */
export const support: Dict<typeof vi> = {
  title: "Customer support",
  subtitle:
    "Tickets from every app in one inbox. Tickets live in each app; the hub pulls the list every minute, and opening a ticket reads it live from the app.",
  countActive: "Open",
  countNeedsReply: "Waiting on us",
  countUnassigned: "Unassigned",
  countMine: "Mine",
  countSlaBreached: "Past first-response target",

  filterApp: "App",
  filterAllApps: "All apps",
  filterStatus: "Status",
  filterActive: "Open (not done)",
  filterAll: "All",
  filterPriority: "Priority",
  filterAnyPriority: "Any",
  filterAssignee: "Assignee",
  filterAnyone: "Anyone",
  filterMine: "Mine",
  filterUnassigned: "Unassigned",
  filterNeedsReply: "Only tickets the customer is waiting on",
  searchPlaceholder: "Search by code or subject",
  search: "Search",
  loadMore: "Load more",
  loadFailed: "Could not load the inbox.",
  empty: "No tickets match these filters.",

  sourcesNotConfigured: "Not connected to the inbox: {apps}.",
  sourcesNever: "Never synced: {apps}.",
  sourceMisconfigured: "{app}: hub config is invalid ({error}) — the hub keeps running, this app is left out of the inbox. Fix the variable in Infisical and redeploy bube-hq.",
  sourceError: "{app}: {error} (last successful sync: {at})",
  never: "never",

  colCode: "Code",
  colSubject: "Subject",
  colStatus: "Status",
  colPriority: "Priority",
  colWaitingOn: "Waiting on",
  colAssignee: "Assignee",
  colSla: "First response",
  colActivity: "Activity",
  waitingOnStaff: "Bube",
  waitingOnCustomer: "Customer",
  unassigned: "—",

  "status.open": "Awaiting support",
  "status.in_progress": "In progress",
  "status.waiting": "Awaiting customer",
  "status.resolved": "Resolved",
  "status.closed": "Closed",
  "priority.low": "Low",
  "priority.normal": "Normal",
  "priority.high": "High",
  "priority.urgent": "Urgent",
  "category.question": "Question",
  "category.bug": "Bug",
  "category.billing": "Billing",
  "category.account": "Account",
  "category.feature_request": "Feature request",
  "category.other": "Other",
  "sla.met": "On time",
  "sla.pending": "Due {at}",
  "sla.breached": "Overdue",

  backToInbox: "← Support inbox",
  detailFailed: "Could not read the ticket from the app.",
  requester: "From",
  workspace: "Workspace",
  openWorkspace: "View workspace",
  createdAt: "Sent {at}",
  thread: "Conversation",
  fromCustomer: "Customer",
  fromStaff: "Bube",
  fromSystem: "System",
  replyPlaceholder: "Reply to the customer… (they get it in the app and by email)",
  send: "Send reply",
  sendAndResolve: "Send & mark resolved",
  sending: "Sending…",
  sendFailed: "Could not send",
  closedHint: "This ticket is closed — the customer has to open a new one.",
  noReplyPermission: "You can only view tickets.",

  panelStatus: "Status",
  panelPriority: "Priority",
  panelAssignee: "Assignee",
  panelSla: "First-response target",
  takeIt: "Take it",
  unassign: "Unassign",
  nobody: "Unassigned",
  saveFailed: "Could not save",

  notes: "Internal notes ({count})",
  notesHint: "Customers never see these notes.",
  notePlaceholder: "Note for teammates…",
  addNote: "Add note",
  noNotes: "No notes yet.",
};
